<template>
  <div class="home split-screen" :style="{height: `${$store.getters.fullHeight}px`}">
    <div class="color-half">
      <div class="container">
        <p class="page-title">Heat Capacity</p>

        <div class="content">
          <h1>Specific Heat Capacity</h1>

          <p><strong>You are an engineer</strong> preparing to build a new home. You want to use material that will keep the house well insulated so it will be more energy efficient. <strong>One factor affecting your decision is the heat capacity of the materials.</strong></p>


          <div class="btn-row">
            <router-link to="/quiz/materials" class="btn hollow">Skip To Quiz</router-link>
            <router-link to="/review" class="btn">Learn More&nbsp;&rarr;</router-link>
          </div>
        </div>
      </div>
    </div>

        <video class="pic-half" autoplay muted loop :style="{maxHeight: `${$store.getters.fullHeight}px`}">
          <source src="../assets/science.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video> 
      <!-- <img src="../assets/fire.jpg" class="pic-half" /> -->
      
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
}
</script>

<style lang="scss">
  .content{
    text-align: left;
    margin-top: 2.5rem;
    font-size: 1.3rem;

    h1{
      font-size: 2.4rem;
      margin-top: 0;
      font-weight: normal;
    }

    h2{
      margin-top: 0rem;
    }

    .btn-row{
      display: flex;
      justify-content: flex-end;
      margin-top: 5rem;

      .btn:last-of-type{
        margin-left: 1rem;
      }
    }
  }
</style>
